import { Utilities as utilities } from '@truckdown/framework';

export class Sequence {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, '_id', '');
            this.name = utilities.json.getStringValue(json, 'n', '');
            this.value = utilities.json.getNumberValue(json, 'v', 0);
            this.modifiedTime = utilities.json.getDateValue(json, 'mt', new Date());
        }
    }

    id: string = '';
    name: string = '';
    value: number = 0;
    modifiedTime: Date = new Date()
}